import moment from "moment"
import { getUsersModulePath } from "../../helpers/Utils"

export default (context) => {
  let years = []
  let year = 2021
  const currentYear = parseInt(moment().format('Y'))
  while (year <= currentYear) {
    years.push({ value: year, label: year.toString() })
    year++
  }
  const usersPath = getUsersModulePath()
  return {
      config: {
        pageSize: 40,
        list: false,
        customPathGet: "admOrder/getGrid",
        customPathPost: "admOrder/createbulk"
      },
    
      actions: {
        create: {
          reloadGrid: true,
          btn: (ctx) => {
            ctx.state.formFlags.bulk = false
            ctx.toggle();
          }
        },
        edit: false,
        delete: false,
        print: true,
        export: true,
        search: true
      },

      extras: {
        items: [
          { icon: 'simple-icon-reload', name: 'En masivo', onClick: (ctx) => {
              ctx.state.formFlags.bulk = true
              ctx.toggle();
            } 
          }
        ],
        itemsInRowsTable: [
          { icon: 'simple-icon-eye', name: 'Ver mensualidades', onClick: (rowData, ctx) => {
              let obj = {
                module: 'admOrder',
                params: [
                  {
                    name: "studentId",
                    value: {value: rowData.ID, label: rowData.name},
                    type: "select",
                    label: "Alumno",
                    opts: {
                      style: 'float-label',
                      searchOnline: true,
                      path: `/${usersPath}/get?pick=true`,
                      withImg: true
                    }
                  },
                  {
                    name: "range",
                    value: 2,
                    type: "select",
                    label: "main.dateRange",
                    opts: {
                      style: 'float-label',
                      items: [
                        {value: 0, label: "main.lastWeek"},
                        {value: 1, label: "main.lastMonth"},
                        {value: 2, label: "main.custom"}
                      ]
                    },
                    onChange: (ctx) => {
                      if (ctx.state.range === 0) ctx.setState({from: moment().add(-7, 'days').format(), to: moment().format()})
                      else if (ctx.state.range === 1) ctx.setState({from: moment().add(-30, 'days').format(), to: moment().format()})
                      // else ctx.setState({from: null, to: null})
                    }
                  },
                  {
                    name: "from",
                    value: new Date(ctx.state.formFilter.year,0,1),
                    type: "date",
                    label: "main.from",
                    opts: {
                      style: 'float-label',
                      selectsStart: true,
                      startDate: (ctx) => ctx.state.from ? moment(ctx.state.from) : null,
                      endDate: (ctx) => ctx.state.to ? moment(ctx.state.to) : null
                    },
                    renderIf: ctx => ctx.state.range === 2
                  },
                  {
                    name: "to",
                    value: new Date(ctx.state.formFilter.year+1,0,1),
                    type: "date",
                    label: "main.to",
                    opts: {
                      style: 'float-label',
                      selectsEnd: true,
                      startDate: (ctx) => moment(ctx.state.from),
                      endDate: (ctx) => moment(ctx.state.to),
                      minDate: (ctx) => moment(ctx.state.from)
                    },
                    renderIf: ctx => ctx.state.range === 2 && ctx.state.from
                  }
                ],
                type: 0,
                keepFilters: true
              }
              ctx.props.setDeeplink(obj, ctx.props.history)
            }
          },
          { icon: 'simple-icon-eye',  name: 'Ver pagos', onClick: (rowData, ctx) => {
              let obj = {
                module: 'admBilling',
                params: [
                  {
                    name: "studentId",
                    value: {value: rowData.ID, label: rowData.name},
                    type: "select",
                    label: "Alumno",
                    opts: {
                      style: 'float-label',
                      searchOnline: true,
                      path: `/${usersPath}/get?pick=true`,
                      withImg: true
                    }
                  }
                ],
                type: 0,
                keepFilters: true
              }
              ctx.props.setDeeplink(obj, ctx.props.history)
            }
          }
        ]
      },

      filter: {
        fields: [
          {
            name: "year",
            value: currentYear,
            type: "select",
            label: "Año",
            rules: 'required',
            opts: {
              style: 'float-label',
              items: years
            }
          },
          {
            name: "sectionId",
            value: "",
            type: "select",
            label: "Sección",
            opts: {
              style: 'float-label',
              searchOnline: true,
              path: "/admSection/get?pick=true"
            }
          }
        ],
        buttons: [
          {
            label: 'Aplicar filtro',
            renderIf: (ctx) => { return ctx.state.year || ctx.state.sectionId },
            onClick: (ctx) => { ctx.btnAction('filter') }
          }
        ]
      },

      form: {
        flags:{
          bulk: false
        },
        setValuesBeforePost: (values) => {
          values.months = values.months || []
          values.userIdsFor = values.userIdsFor || []
          values.userIdsForBulk = values.userIdsForBulk || null
          values.forYear = values.forYear ? parseInt(values.forYear) : 0
          delete values.flags
          return values
        },
        fields: [
          {
            col: 12,
            name: "userIdsFor",
            value: "",
            type: "select",
            label: "Alumno",
            rules: 'required',
            renderIf: (ctx) => { return !ctx.state.flags.bulk },
            opts: {
              style: 'float-label',
              isMulti: true,
              searchOnline: true,
              path: `/${usersPath}/get?pick=true`,
              withImg: true
            }
          },
          {
            col: 12,
            name: "userIdsForBulk",
            value: "",
            type: "textarea",
            label: "Para los siguientes alumnos",
            rules: 'required',
            renderIf: (ctx) => { return ctx.state.flags.bulk },
            opts: {
              style: 'float-label',
            }
          },
          {
            col: 12,
            name: "recurrent",
            value: false,
            type: "switch",
            hint: "Recurrente",
            label: "El último día del mes",
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 12,
            name: "months",
            value: "",
            type: "select",
            label: "Para meses",
            rules: 'required',
            renderIf: (ctx) => { return ctx.state.recurrent },
            opts: {
              style: 'float-label',
              isMulti: true,
              items: [
                {
                  value: 1,
                  label: "Enero"
                },
                {
                  value: 2,
                  label: "Febrero"
                },
                {
                  value: 3,
                  label: "Marzo"
                },
                {
                  value: 4,
                  label: "Abril"
                },
                {
                  value: 5,
                  label: "Mayo"
                },
                {
                  value: 6,
                  label: "Junio"
                },
                {
                  value: 7,
                  label: "Julio"
                },
                {
                  value: 8,
                  label: "Agosto"
                },
                {
                  value: 9,
                  label: "Setiembre"
                },
                {
                  value: 10,
                  label: "Octubre"
                },
                {
                  value: 11,
                  label: "Noviembre"
                },
                {
                  value: 12,
                  label: "Diciembre"
                }
              ]
            }
          },
          {
            col: 12,
            name: "forYear",
            value: "",
            type: "select",
            label: "Para año",
            rules: 'required',
            renderIf: (ctx) => { return ctx.state.recurrent },
            opts: {
              style: 'float-label',
              path: "/admActivity/get?type=ayr",
              remap: (r) => {
                return {
                  data: {
                    Results: r.data.Results.map(e => e = {ID: moment(e.startDate).format('Y'), name: moment(e.startDate).format('Y')}),
                  },
                  msg: r.msg,
                  status: r.status
                }
              }
            }
          },
          {
            col: 12,
            name: "brief",
            value: null,
            type: "text",
            label: "Descripción / Concepto general",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 12,
            name: "dueDate",
            value: null,
            type: "date",
            label: "Fecha de vencimiento",
            rules: 'required',
            renderIf: (ctx) => { return !ctx.state.recurrent },
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept1",
            value: null,
            type: "text",
            label: "Concepto 1",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept1amount",
            value: null,
            type: "number",
            label: "Monto 1",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept2",
            value: null,
            type: "text",
            label: "Concepto 2",
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept2amount",
            value: null,
            type: "number",
            label: "Monto 2",
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept3",
            value: null,
            type: "text",
            label: "Concepto 3",
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "concept3amount",
            value: null,
            type: "number",
            label: "Monto 3",
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 12,
            name: "clearDetail",
            value: false,
            type: "switch",
            hint: "Eliminar conceptos existentes",
            label: 'Se reenplazarán los conceptos existentes por los conceptos de arriba',
            opts: {
              style: 'float-label'
            },
            renderIf: (ctx) => ctx.state.recurrent,
          },
          {
            col: 12,
            name: "hasPenalty",
            value: false,
            type: "switch",
            label: "Cobrar penalidad por pago tardío",
            opts: {
              style: 'float-label'
            }
          }
        ]
      },

      columns: [
        {
          Header: "ID",
          accessor: "ID",
          minWidth: 60
        },
        {
          Header: "Nombre",
          accessor: "name"
        },
        {
          Header: "Grado / Sección",
          accessor: "sectionTag"
        },
        {
          Header: "ID Externo",
          accessor: "externalId"
        },
        {
          Header: "1",
          accessor: "M1",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "2",
          accessor: "M2",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "3",
          accessor: "M3",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "4",
          accessor: "M4",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "5",
          accessor: "M5",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "6",
          accessor: "M6",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "7",
          accessor: "M7",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "8",
          accessor: "M8",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "9",
          accessor: "M9",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "10",
          accessor: "M10",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "11",
          accessor: "M11",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "12",
          accessor: "M12",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "Beca",
          accessor: "condition",
          isBool: true,
          minWidth: 50
        }
      ]
  }
}